import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Misteri from "@/pages/Misteri";
import Dossier from "@/pages/Dossier";
import Classifica from "@/pages/Classifica";
import Profilo from "@/pages/Profilo";
import Login from "@/pages/Login";
import { Privacy, Cookie } from "@/pages/Legal";
import AuthCallback from "@/pages/AuthCallback";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminDossier from "@/pages/admin/AdminDossier";

function AdminGate({ children }) {
  const { user } = useAuth();
  if (user === null) return <p className="py-20 text-center text-muted-foreground">Verifica accesso…</p>;
  if (!user || user.role !== "admin")
    return (
      <p data-testid="admin-forbidden" className="py-20 text-center text-muted-foreground">
        Area riservata a Lumacofono · Fondatore.
      </p>
    );
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/misteri" element={<Misteri />} />
        <Route path="/dossier/:id" element={<Dossier />} />
        <Route path="/classifica" element={<Classifica />} />
        <Route path="/profilo" element={<Profilo />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookie" element={<Cookie />} />
        <Route path="/admin" element={<AdminGate><AdminDashboard /></AdminGate>} />
        <Route path="/admin/dossier/:id" element={<AdminGate><AdminDossier /></AdminGate>} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}
